import { initReactI18next } from 'react-i18next';
import { getLocales } from 'react-native-localize';
import i18n from 'i18next';

import { resources } from './languages';

i18n.use(initReactI18next).init({
  lng: getLocales()[0]?.languageCode || 'en',
  fallbackLng: 'en',
  resources,
});

export default i18n;
